(function () {
  if (window.__bundleCartBehaviorInstalled) return;
  window.__bundleCartBehaviorInstalled = true;

  function parseJson(response) {
    return response.json().then(function (data) {
      if (!response.ok) {
        throw new Error(data.description || data.message || data.error || 'cart_request_failed');
      }
      return data;
    });
  }

  function cartSectionIds() {
    return Array.from(document.querySelectorAll('[ref="hdt-cart"][section-id]'))
      .map(function (element) { return element.getAttribute('section-id'); })
      .filter(function (id, index, ids) { return id && ids.indexOf(id) === index; });
  }

  function replaceSections(sections) {
    if (!sections) return;

    Object.keys(sections).forEach(function (sectionId) {
      var current = document.getElementById('shopify-section-' + sectionId);
      if (!current || !sections[sectionId]) return;

      var parsed = new DOMParser().parseFromString(sections[sectionId], 'text/html');
      var freshWrapper = parsed.getElementById('shopify-section-' + sectionId);
      if (freshWrapper) {
        current.replaceWith(freshWrapper);
        return;
      }

      var currentCart = current.querySelector('[ref="hdt-cart"][section-id]');
      var freshCart = parsed.querySelector('[ref="hdt-cart"][section-id]');
      if (currentCart && freshCart) currentCart.replaceWith(freshCart);
    });
  }

  function updateCount(cart) {
    if (!cart || typeof cart.item_count !== 'number') return;

    document.querySelectorAll('[data-cart-count], .hdt-cart-count').forEach(function (element) {
      if (!element.children.length) element.textContent = String(cart.item_count);
      element.setAttribute('data-cart-count', String(cart.item_count));
    });

    document.dispatchEvent(new CustomEvent('cart:count:update', {
      detail: { item_count: cart.item_count, total_price: cart.total_price }
    }));
  }

  function openDrawer() {
    var trigger = document.querySelector('[aria-controls="CartDrawer"]');
    if (trigger) {
      trigger.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
      return;
    }

    var dialog = document.getElementById('CartDrawer');
    if (dialog && typeof dialog.showModal === 'function' && !dialog.open) dialog.showModal();
  }

  function removeBundle(bundleId, button) {
    if (!bundleId || window.__bundleCartRemoving) return;
    window.__bundleCartRemoving = true;
    if (button) button.disabled = true;

    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js', {
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      cache: 'no-store'
    })
      .then(parseJson)
      .then(function (cart) {
        var updates = {};
        (cart.items || []).forEach(function (item) {
          if (item.properties && item.properties._bundle_id === bundleId) updates[item.key] = 0;
        });

        if (!Object.keys(updates).length) return cart;

        var sections = cartSectionIds();
        return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({
            updates: updates,
            sections: sections.join(','),
            sections_url: window.location.pathname
          })
        }).then(parseJson);
      })
      .then(function (cart) {
        if (!cart) return;
        replaceSections(cart.sections);
        updateCount(cart);
        document.dispatchEvent(new CustomEvent('cart:reload'));
        if (cart.item_count > 0 && !document.querySelector('hdt-main-cart')) {
          requestAnimationFrame(function () { requestAnimationFrame(openDrawer); });
        }
      })
      .catch(function (error) {
        console.error('[Bundle] Could not remove the full bundle:', error);
        window.location.reload();
      })
      .finally(function () {
        window.__bundleCartRemoving = false;
        if (button && button.isConnected) button.disabled = false;
      });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-bundle-remove]');
    if (!button) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    removeBundle(button.getAttribute('data-bundle-remove'), button);
  }, true);
})();
